var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.doc)?_c('div',{staticClass:"essay-body"},[_c('rich-text',{attrs:{"field":_vm.doc.data.body[0].items[0].text}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }